import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import Video from '@nmx/template/dist/componentLibrary/components/Video';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import ScrollToAnchorCta from '../../../components/scrollToAnchorCta';
// styles
import { ColStyled } from './styles';

export default ({ videoId }) => {
  return (
    <SectionContainer
      id='private-wealth-management-intro'
      backgroundVariant='lightB'
      themeType='lightTheme'
      moduleName='intro-module'
      moduleVariation='A'>
      <Row align='center'>
        <ColStyled
          medium={6}
          align='center'>
          <Video
            id={videoId}
            title='Northwestern Mutual Private Client Group'
          />
        </ColStyled>
        <Col medium={6}>
          <Typography
            component='h2'
            accent='pcgHeading'
            accentColorVariant='pcg'
            align='left'
            branding='pcg'
            disableBottomPadding>
            The one financial partnership that goes beyond <WidowBlock>your portfolio.</WidowBlock>
          </Typography>
          <Typography
            align='left'
            nextElement='button'>
            Our comprehensive approach to private wealth management will help you and your family enjoy your wealth today, and for generations to come.
          </Typography>
          <ScrollToAnchorCta
            id='private-wealth-management-pcg-directory-cta'
            variant='buttonLinkPrimary'
            themeType='darkTheme'
            branding='pcg'
            targetId='private-wealth-management-pcg-directory-section-container'
            ariaLabel='Use our directory to find a private client group advisor'>
            Find a private client group advisor
          </ScrollToAnchorCta>
        </Col>
      </Row>
    </SectionContainer>
  );
};
